import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { push } from "react-router-redux";

import {
  selectFirstName,
  selectLastName,
  selectProfileAvatarUrl,
  selectProfileHostHeardFrom,
} from "../app-main/selectors/profile.selectors";
import { ProfilePage } from "../elements-forms/ProfilePage";

// The store is still plain JS, so there's no canonical `AppDispatch` to import.
// `updateProfile` is a thunk that resolves (or rejects) with the dispatched action.
type Dispatch = (action: unknown) => Promise<unknown>;

export type HostProfileMainProps = {
  routeParams: { spaceId: string };
};

export const HostProfileMain = ({ routeParams }: HostProfileMainProps) => {
  const dispatch = useDispatch() as Dispatch;

  const hasHostHeardFrom = useSelector(selectProfileHostHeardFrom)?.length > 0;
  const firstName = useSelector(selectFirstName);
  const lastName = useSelector(selectLastName);
  const avatarUrl = useSelector(selectProfileAvatarUrl);

  const { spaceId } = routeParams;

  useEffect(() => {
    if (
      hasHostHeardFrom &&
      firstName?.length &&
      lastName?.length &&
      avatarUrl?.length
    ) {
      dispatch(push(`/your-space/${spaceId}/confirmation`));
    }
  }, [dispatch, hasHostHeardFrom, spaceId, firstName, lastName, avatarUrl]);

  return (
    <div className="ps-container-lg-margin ps-container-fixed">
      <div className="ps-row">
        <ProfilePage />
      </div>
    </div>
  );
};
